var map = {
	"./star_sentence1.png": "3008",
	"./star_sentence10.png": "0408",
	"./star_sentence2.png": "4c2d",
	"./star_sentence3.png": "76ee",
	"./star_sentence4.png": "b436",
	"./star_sentence5.png": "125a",
	"./star_sentence6.png": "f5c1",
	"./star_sentence7.png": "774d",
	"./star_sentence8.png": "591d",
	"./star_sentence9.png": "8794",
	"./star_sentence_select1.png": "29c1",
	"./star_sentence_select10.png": "a15c",
	"./star_sentence_select2.png": "f1a5",
	"./star_sentence_select3.png": "2afe",
	"./star_sentence_select4.png": "22ac",
	"./star_sentence_select5.png": "19ad",
	"./star_sentence_select6.png": "faba",
	"./star_sentence_select7.png": "16c8",
	"./star_sentence_select8.png": "d10e",
	"./star_sentence_select9.png": "ef00",
	"./star_sentence_un1.png": "22dd",
	"./star_sentence_un10.png": "ef3f",
	"./star_sentence_un2.png": "f6eb",
	"./star_sentence_un3.png": "6774",
	"./star_sentence_un4.png": "5053",
	"./star_sentence_un5.png": "485d",
	"./star_sentence_un6.png": "c8f0",
	"./star_sentence_un7.png": "147c",
	"./star_sentence_un8.png": "c30f",
	"./star_sentence_un9.png": "78a7",
	"./star_sentence_un_select1.png": "d289",
	"./star_sentence_un_select10.png": "d347",
	"./star_sentence_un_select2.png": "f1d4",
	"./star_sentence_un_select3.png": "33fa",
	"./star_sentence_un_select4.png": "6464",
	"./star_sentence_un_select5.png": "f492",
	"./star_sentence_un_select6.png": "1620",
	"./star_sentence_un_select7.png": "9fb7",
	"./star_sentence_un_select8.png": "c747",
	"./star_sentence_un_select9.png": "c326"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9edb";